import { render, staticRenderFns } from "./address-manage.vue?vue&type=template&id=3fb1f7f1&scoped=true&"
import script from "./address-manage.vue?vue&type=script&lang=js&"
export * from "./address-manage.vue?vue&type=script&lang=js&"
import style0 from "./address-manage.vue?vue&type=style&index=0&id=3fb1f7f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb1f7f1",
  null
  
)

export default component.exports